import React from 'react';
import {
  Button as ButtonLib,
  ButtonVariant as ButtonLibVariant,
  Icon,
} from '@sparknz/spark-pattern-library';

import extractCQStyle, { CQStyleMap } from 'shared/utils/extractCQStyle';
import { ButtonEditConfig, ButtonProps } from './ButtonEditConfig';

export type ButtonVariant =
  | 'tableOfContents'
  | 'printThisPage'
  | ButtonLibVariant;

const variantPropCQStyleMap: CQStyleMap<ButtonVariant> = {
  'button--default': 'default',
  'button--primary': 'primary',
  'button--destructive': 'destructive',
  'button--text': 'textbutton',
  'button--tableOfContents': 'tableOfContents',
  'button--printThisPage': 'printThisPage',
};

export type ButtonStateType =
  | 'standard'
  | 'hover'
  | 'active'
  | 'focused'
  | 'disabled'
  | 'isLoading';

const Button = (props: React.PropsWithChildren<ButtonProps>) => {
  if (ButtonEditConfig.isEmpty(props)) {
    return null;
  }

  const { text, buttonLink: link, appliedCssClassNames: cssClassNames } = props;

  const shouldOpenNew = link?.attributes?.target === '_blank';

  const variantStyle =
    extractCQStyle(variantPropCQStyleMap, cssClassNames) || 'default';

  if (variantStyle === 'tableOfContents') {
    return (
      <ButtonLib
        component="a"
        href={link.url}
        target={shouldOpenNew ? '_blank' : undefined}
        variant="textbutton"
        disabled={false}
        isLoading={false}
        className={variantStyle}
        textStyle="bodyMDemi"
        leftContent={<Icon name="jump_to_extra_small" />}
      >
        {text}
      </ButtonLib>
    );
  }
  if (variantStyle === 'printThisPage') {
    return (
      <ButtonLib
        component="button"
        onClick={() => window.print()}
        target={shouldOpenNew ? '_blank' : undefined}
        variant="textbutton"
        disabled={false}
        isLoading={false}
        className={variantStyle}
        textStyle="bodyMDemi"
      >
        {text}
      </ButtonLib>
    );
  }
  return (
    <ButtonLib
      component="a"
      href={link.url}
      target={shouldOpenNew ? '_blank' : undefined}
      variant={variantStyle}
      disabled={false}
      isLoading={false}
      className={variantStyle}
    >
      {text}
    </ButtonLib>
  );
};

export default Button;
